import {ApiClientCommunication} from 'neo-common';

export class FreeRoundsOffersResponse extends ApiClientCommunication.ResponseBase {

    /**
     * @property currentOffer
     */
    currentOffer: {
        /**
         * @property id - Unique identifier of offer.
         */
        id: number;

        /**
         * @property status - URL for terms of campaign. Optional.
         */
        termsUrl: string;

        /**
         * @property roundsAssigned - Number of game rounds assigned to player.
         */
        roundsAssigned: number;

        /**
         * @property roundsStarted - Number of game rounds started by player.
         */
        roundsStarted: number;

        /**
         * @property roundsStarted - Number of game rounds finished by player.
         */
        roundsPlayed: number;

        /**
         * @property remainingCount - Number of remaining free rounds.
         */
        remainingCount: number;

        /**
         * @property status - Status of offer. Can be one of:
         •	new
         Offer was not activated yet.
         •	active
         Offer was already activated.
         */
        status: string;

        /**
         * @property playing - Indicator whether the specified game in free round offer is currently in progress.
         */
        playing: boolean;

        /**
         * @property winType - Type of wins in offer. Can be one of:
         •	bonus
         Wins will be added as bonus money.
         •	real
         Wins will be added as real money.
         */
        winType: string;

        /**
         * @property winType - Time when offer ends.
         */
        validTo: string;

        /**
         * @property winPayMethod - Type of FreeRounds:
         •	cumulative
         All wins are gathered in the win box and collected after last FRB, gamble is always disabled.
         •	separate
         Each game round is collected separatelly, gamble may be enabled.
         */
        winPayMethod: string;

        /**
         * @property collectPartial - Take into account only if 'cumulative' FreeRoundsWinPayMethod is sent
         •	true
         Wins from closed FRB game rounds are collected to player's balance.
         •	false
         All FRB game rounds and wins are cancelled.
         */
        collectPartial: boolean;

        /**
         * @property hasBuyFeature - Take into account if the FRB triggers game feature free rounds
         •	true
         Display special feature message
         •	false
         Display regular FRB message
         */
        hasBuyFeature: boolean;

        /**
         * @property buyFeatureName - Type of feature used in feature free rounds
         •	HoldAndWin
         •	FreeSpins
         */
        buyFeatureName: string;
    };

    /**
     * @property otherOffers - array of all offers without actual playing game
     */
    otherOffers: Array<Object>;

    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/FreeRoundsOffersResponse.ts
 **/